import React, { useEffect, useRef, useState } from 'react';
import { Timeline } from '@innovationnorway/cl-react';
import { TimelineStep } from '@innovationnorway/cl-react/dist/types/components/timeline/timeline';
import { slugify } from '../../utils/slugify';

type OpportunityTimelineProps = {
  stepNames: string[];
};

const OpportunityTimeline: React.FC<OpportunityTimelineProps> = ({ stepNames: names }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [activeAnchor, setActiveAnchor] = useState<string | null>(null);

  useEffect(() => {
    const ids = names.map((name) => slugify(name)).filter(Boolean) as string[];

    const handleScroll = () => {
      const stickyHeaderHeight = containerRef.current
        ? parseFloat(getComputedStyle(containerRef.current).getPropertyValue('--owi-sticky-header-height')) ||
          0
        : 0;
      const threshold = stickyHeaderHeight + 16 + 1;
      let current: string | null = null;
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= threshold) {
          current = `#${id}`;
        }
      }
      const isAtBottom = window.innerHeight + window.scrollY >= document.body.scrollHeight - 4;
      if (isAtBottom && ids.length > 0) {
        current = `#${ids[ids.length - 1]}`;
      }
      if (current === null && ids.length > 0) {
        current = `#${ids[0]}`;
      }
      setActiveAnchor(current);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [names]);

  const steps: TimelineStep[] = names
    .filter((name) => name.trim())
    .map((name) => {
      const url = `#${slugify(name)}`;
      return {
        name,
        iconName: 'Rocket',
        url,
        active: activeAnchor === url,
      };
    });

  return (
    <div className="opportunity-timeline--container" ref={containerRef}>
      <Timeline steps={steps} layout="vertical" />
    </div>
  );
};

export default OpportunityTimeline;
